import { styled } from "@mui/system";

export const ScrollButton = styled("button")(({ isVisible }) => ({
  position: "fixed",
  bottom: "40px",
  right: "40px",
  width: "50px",
  height: "50px",
  borderRadius: "50%",
  backgroundColor: "#1D2862",
  color: "#FFFFFF",
  border: "2px solid #FFFFFF",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "20px",
  transition: "all 0.3s ease",
  opacity: isVisible ? 1 : 0,
  visibility: isVisible ? "visible" : "hidden",
  transform: isVisible ? "translateY(0)" : "translateY(20px)",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  zIndex: 1000,
  "&:hover": {
    backgroundColor: "#2a3a8a",
    transform: "translateY(-5px)",
    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
  },
  "@media (max-width: 600px)": {
    bottom: "20px",
    right: "20px",
    width: "40px",
    height: "40px",
    fontSize: "16px",
  },
}));
